import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { CSSProperties } from 'react';

interface DocumentationPluginCardProps {
  name: string;
  logo: string;
  logoStyle?: CSSProperties;
  documentation_url: string;
}

const DocumentationPluginCard = (props: DocumentationPluginCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      component="a"
      href={props.documentation_url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Ver documentación de ${props.name} (abre en una nueva pestaña)`}
      elevation={3}
      className="group relative flex h-24 w-full items-center justify-center overflow-hidden no-underline"
      sx={{
        transition: 'box-shadow 0.2s ease',
        '&:hover': { boxShadow: theme.shadows[6] },
      }}
    >
      <img
        src={props.logo}
        alt={props.name}
        style={{ height: 28, maxWidth: '140px', ...props.logoStyle }}
      />
      <OpenInNewIcon
        aria-hidden
        sx={{
          position: 'absolute',
          bottom: 8,
          right: 8,
          fontSize: 18,
          color: theme.palette.grey[500],
        }}
      />

      {/* El overlay se muestra solo con CSS (group-hover) para no necesitar estado */}
      <div
        className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-1 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        style={{ backgroundColor: theme.palette.primary.main }}
      >
        <OpenInNewIcon sx={{ color: '#fff', fontSize: 28 }} />
        <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700 }}>
          Ver documentación
        </Typography>
      </div>
    </Paper>
  );
};

export default DocumentationPluginCard;
